import { Suspense } from "react";

import ErrorBoundary from "common/components/ErrorBoundary";

import LoadingContainer from "client/common/components/loading/LoadingContainer";
import Block from "client/products/blocks/components/Block";

import { StorefrontCollection } from "../types";

import styles from "../styles/CollectionContentBlocks.module.less";

type CollectionContentBlocksProps = {
  collection: StorefrontCollection;
};

/**
 * The collection's marketing blocks, rendered through the same Block component the product detail
 * page uses. Wrapped per block because the JSON is authored in admin: a bad one drops alone.
 */
const CollectionContentBlocks = ({ collection }: CollectionContentBlocksProps) => {
  if (!collection.contents.length) {
    return null;
  }

  return (
    <Suspense fallback={<LoadingContainer />}>
      <div className={styles.blocks}>
        {collection.contents.map((content) => (
          <ErrorBoundary key={content.id} shouldReportErrors={false} fallback={null}>
            <Block block={content.block} />
          </ErrorBoundary>
        ))}
      </div>
    </Suspense>
  );
};

export default CollectionContentBlocks;
